import type { Game } from "./types";

export const gameList: Game[] = [
	{
		type: "snake-game",
		name: "Snake Game",
		description: "Snake Game. Play the game and learn spelling",
		image:
			"https://res.cloudinary.com/nzmai/image/upload/v1728476426/language-school/images/snake-game-image.webp",
	},
	{
		type: "blurred-image-game",
		name: "Blurred Image Game",
		description: "Blurred Image Game. Play the game and learn spelling",
		image:
			"https://res.cloudinary.com/nzmai/image/upload/v1728476658/language-school/images/blurred-game-image.webp",
	},
	{
		type: "memory-card-game",
		name: "Memory Card Game",
		description: "Memory Card Game. Play the game and memorize words",
		image:
			"https://res.cloudinary.com/nzmai/image/upload/v1728476764/language-school/images/flip-card-game.webp",
	},
];
